<!--https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/*/-->

<script>
export default {
	name: "TransitionExpand",
	functional: true,
	props: {
		show: {
			type: Boolean,
			default: true
		}
	},
	render(createElement, context) {
		const data = {
			props: {
				name: "expand"
			},
			on: {
				afterEnter(element) {
					setTimeout(function () {
						element.style.height = "auto";
						element.style.overflow = "visible";
					}, 10);
				},
				enter(element) {
					if (context.props.show) {
						const { width } = getComputedStyle(element);

						element.style.width = width;
						element.style.position = "absolute";
						element.style.visibility = "hidden";
						element.style.height = "auto";
						element.style.overflow = "visible";

						const { height } = getComputedStyle(element);

						element.style.width = "";
						element.style.position = "";
						element.style.visibility = "";
						element.style.height = 0;
						element.style.overflow = "hidden";

						setTimeout(function () {
							element.style.height = height;
							element.style.overflow = "visible";
						}, 10);
					}
				},
				leave(element) {
					const { height } = getComputedStyle(element);
					element.style.height = height;
					element.style.overflow = "visible";

					setTimeout(function () {
						element.style.height = 0;
						element.style.overflow = "hidden";
					}, 10);
				}
			}
		};

		return createElement("transition", data, context.children);
	}
};
</script>

<style lang="scss" scoped>
* {
	backface-visibility: hidden;
	will-change: height;
}

.expand-enter-active,
.expand-leave-active {
	overflow: hidden;
	transition: height 0.5s ease;
}

.expand-enter,
.expand-leave-to {
	height: 0;
}
</style>
